<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      console.log("案件类型数据",data)
      let _this = this;
      let setOptionStyle = {
        grid: {
          left: "5%",
          right: "2%",
          bottom: "10%",
        },
        legend: {
          textStyle: {
            color: "#409EFF",
          },
          //   right: "5%",
          top: "0%",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
        },
        xAxis: {
          type: "category",
          data: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
        ],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
          splitArea: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [
          {
            name: "聚众斗殴罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            stack: "one",
            barMaxWidth: 30,
            itemStyle: {
              color: "#6390f9",
            },
          },
          {
            name: "寻衅滋事",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "校园霸凌",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "故意伤害",

            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "校园严重违纪",

            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "绑架罪",

            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "敲诈勒索罪",

            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "交通肇事罪",

            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "抢夺罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "盗窃罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "诈骗罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "抢劫罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "容留他人吸毒",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "贩卖毒品罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "强奸罪",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "强制猥亵妇女",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "猥亵儿童",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "服务救助",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "实物救助",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "大病救助",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
        ],
      }
      setOptionStyle.series = [];
      if(data!=[]){
        for(var key in data){
        let seriesList ={
            name: "",
            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          }
          seriesList.name = data[key].name;
          seriesList.data = data[key].data;
          setOptionStyle.series.push(seriesList);
      }
      }
      this.chart.setOption(setOptionStyle);
    },
  },
};
</script>
